
const CLASS_HIDDEN_COUNTDOWN = 'countdown-hidden';
const FORCE_REMOVE_COUNTDOWN_QP = 'force_remove_countdown';

const countDownDate = new Date(document.querySelector("#countdown-conf").getAttribute("data-time")).getTime();
const bannerDate = new Date(document.querySelector("#banner-conf").getAttribute("data-time")).getTime();

function toggleCountdownModeElements(elementsToShow, elementsToHide) {
  Array.from(document.getElementsByClassName(elementsToHide)).forEach((elem) => {
    elem.classList.add(CLASS_HIDDEN_COUNTDOWN);
  });

  Array.from(document.getElementsByClassName(elementsToShow)).forEach((elem) => {
    elem.classList.remove(CLASS_HIDDEN_COUNTDOWN);
  });
}

function switchCountdownDisplay(countdownClass, defaultClass, date, countdownElementsClass) {
  const updateCounter = timeDifference => {
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000).toLocaleString(undefined, { minimumIntegerDigits: 2 });
    const endTime = [days, hours, minutes, seconds];

    endTime.forEach((value, index) => {
      parent = document.getElementById(`${countdownElementsClass}${index}`);
      if (parent) parent.innerHTML = value;
    });
  };

  const isForcedRemovedCountdown = () => {
    const params = new URLSearchParams(location.search);
    const forcedValue = params.get(FORCE_REMOVE_COUNTDOWN_QP);

    return (forcedValue === '1' || forcedValue === 'true');
  };

  const calculateDistance = (date) => {
    let now = Date.now();
    return date - now;
  }

  if (isForcedRemovedCountdown()) {
    toggleCountdownModeElements(defaultClass, countdownClass);
    return;
  }

  let timeDifference = calculateDistance(date);

  if (timeDifference < 0) {
    toggleCountdownModeElements(defaultClass, countdownClass);
  } else {
    toggleCountdownModeElements(countdownClass, defaultClass);
    updateCounter(timeDifference);

    const x = setInterval(function () {
      const timeDifference = calculateDistance(date);
      if (timeDifference < 0) {
        clearInterval(x);
        toggleCountdownModeElements(defaultClass, countdownClass);
      } else {
        updateCounter(timeDifference)
      }
    }, 1000);
  }
}

switchCountdownDisplay('countdown-waitlist', 'countdown-default', countDownDate, 'hero_countdown_number_');
switchCountdownDisplay('countdown-banner', 'banner-default', bannerDate, 'banner_countdown_number_');
